import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Page = lazy(() => import('~/features/notifications/list/page-client'))

export const Route = createFileRoute('/_authed/agent/notifications/list')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})
